<template>
  <div class="w-full max-w-lg mx-auto p-4 sm:py-16">
    <RegisterForm @user-registered="onUserRegistered" />
  </div>
</template>

<script>
import RegisterForm from '@/components/Users/RegisterForm.vue';

export default {
  name: 'Register',
  components: {
    RegisterForm,
  },
  methods: {
    onUserRegistered() {
      this.$router.push({ name: 'email.verification.notice' });
    },
  },
};
</script>
